import React, { MouseEventHandler, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAsDetailQuery } from "src/api/asAPI";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual } from "react-redux";
import { getPathValue } from "src/utils/queryStringUtil";
import moment from "moment";
import Box from "../common/Box";
import Button from "../common/Button";
import iconDoc from "src/assets/images/iconDoc.svg";
import iconCheckBlue from "src/assets/images/iconCheckBlue.svg";
import iconCheckRed from "src/assets/images/iconCheckRed.svg";
import iconCheckBlack from "src/assets/images/iconCheckBlack.svg";
import styled from "styled-components";
import cn from "classnames";
import { isEmpty } from "lodash";

interface IBottomProps {
  index: any;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const SelectVender = (props: IBottomProps) => {
  const navigate = useNavigate();
  const index: any = getPathValue();
  if (isEmpty(index)) {
    return <p></p>;
  }
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const asDetail = useAsDetailQuery(props.index);

  const [init, setInit] = useState({
    companyName: "",
    companyPhone: "",
    estimateDate: "",
    estimateState: "",
    completeInfo: "",
    className: "",
    route: "",
  });

  const { companyName, companyPhone, estimateState, estimateDate, completeInfo, className, route } = init;

  useEffect(() => {
    // 견적 진행
    let esState: any = "";
    let className: any = "";
    if (asDetail.data.es_approval_code === "EAC_0") {
      esState = "반려";
      className = "";
    } else if (asDetail.data.es_approval_code === "EAC_10") {
      esState = "견적대기";
      className = "";
    } else if (asDetail.data.es_approval_code === "EAC_20") {
      esState = "견적재요청";
      className = "";
    } else if (asDetail.data.es_approval_code === "EAC_30") {
      esState = "승인대기";
      className = "";
    } else if (asDetail.data.es_approval_code === "EAC_100") {
      esState = "승인";
      className = "check-blue";
    }
    if (asDetail.data.progress_value === "60") {
      setInit({
        ...init,
        estimateDate: asDetail.data.insert_date,
        estimateState: esState,
        completeInfo: "미제출",
      });
    } else if (asDetail.data.progress_value === "70") {
      const esState: any = "무상 A/S";
      setInit({
        ...init,
        estimateDate: asDetail.data.insert_date,
        estimateState: esState,
        completeInfo: "미제출",
      });
    } else if (asDetail.data.progress_value === "80") {
      // const esState: any = "승인";
      setInit({
        ...init,
        estimateDate: asDetail.data.insert_date,
        estimateState: esState,
        completeInfo: "미제출",
        className: className,
      });
    } else if (asDetail.data.progress_value === "100") {
      let setEstimateState: string;
      let setCompleteInfo: any = "";
      let setClassName = "";

      if (asDetail.data.delete_yn === "Y") {
        if (asDetail.data.es_approval_code === "EAC_0") {
          setEstimateState = "반려";
          setClassName = "";
        } else if (asDetail.data.es_approval_code === "EAC_10") {
          setEstimateState = "견적대기";
          setClassName = "";
        } else if (asDetail.data.es_approval_code === "EAC_20") {
          setEstimateState = "견적재요청";
          setClassName = "";
        } else if (asDetail.data.es_approval_code === "EAC_30") {
          setEstimateState = "승인대기";
          setClassName = "";
        } else if (asDetail.data.es_approval_code === "EAC_100") {
          setEstimateState = "승인";
          setClassName = "check-blue";
        } else {
          setEstimateState = "";
        }
      } else {
        setEstimateState = esState;
        setClassName = className;
      }

      if (asDetail.data.completionReport_progress === "ASC_10") {
        setCompleteInfo = "미제출";
      } else if (asDetail.data.completionReport_progress === "ASC_50") {
        setCompleteInfo = "확인대기";
      } else if (asDetail.data.completionReport_progress === "ASC_70") {
        setCompleteInfo = "보완요청";
      } else if (asDetail.data.completionReport_progress === "ASC_100") {
        setCompleteInfo = "승인";
      }
      setInit({
        ...init,
        estimateDate: asDetail.data.insert_date,
        estimateState: setEstimateState,
        completeInfo: setCompleteInfo,
        className: setClassName,
      });
    }
  }, [asDetail]);

  // ============================== 클릭 이벤트 영역 ==============================
  const addVisit = () => {
    navigate("/visitInfo/" + index, { replace: true });
    // if (asDetail.data.es_approval_code === "EAC_100") {
    //   navigate("/visitInfo/" + index);
    // } else {
    //   alert("견적서 승인 후 방문정보를 등록해주세요");
    // }
  };

  const visitInfoMove = () => {
    navigate("/visitInfo/" + index, { state: { deleteYn: asDetail.data.delete_yn, asc: asDetail.data.completionReport_progress } });
    // if (asDetail.data.es_approval_code === "EAC_100") {
    //   navigate("/visitInfo/" + index, { state: { deleteYn: asDetail.data.delete_yn, asc: asDetail.data.completionReport_progress } });
    // } else {
    //   alert("방문정보 등록이 되지 않았습니다.");
    // }
  };

  const addRegister = () => {
    navigate("/estimate-register/" + index, { replace: true });
  };

  const completeRegisteMove = () => {
    // 미제출, 보완요청일때 수정
    if (asDetail.data.completionReport_progress === "ASC_10" || asDetail.data.completionReport_progress === "ASC_70") {
      if (userInfo.user_type === "M") {
        navigate("/report-register/" + index, { replace: true });
      }
    }
  };

  return (
    <Box pd="32px 15px" bg="#f4f5f7">
      {/* 업체 선택 후 */}
      <VenderInfoBox>
        <div>
          <p className="name">{asDetail.data.company_name}</p>
          <p className="tel">{asDetail.data.company_phone_number}</p>
        </div>
        {userInfo.user_type === "E" && asDetail.data.progress_value <= 60 && isEmpty(asDetail.data.visit_date) ? (
          <div>
            {asDetail.data.es_approval_code === "EAC_10" || asDetail.data.es_approval_code === "EAC_0" ? (
              <>
                {asDetail.data.delete_yn !== "Y" ? (
                  <Button variant="outlined" size="small" br="round" color="subWhite" onClick={props.onClick}>
                    변경
                  </Button>
                ) : (
                  "취소"
                )}
              </>
            ) : (
              ""
            )}
          </div>
        ) : null}
      </VenderInfoBox>
      <VenderStatusBox>
        <li>
          {/* a tag error */}
          {/* 매장은 아울렛과 대리점만 견적서 볼 수 있음  */}
          {userInfo.user_type === "E" || userInfo.user_type === "M" ? (
            <>
              {asDetail.data.es_approval_code !== "EAC_10" ? (
                <Link to={"/estimate-detail/" + asDetail.data.es_idx} className="has-data">
                  <span>
                    {asDetail.data.free_yn === "Y" ? "무상견적서" : "견적서"}
                    {/* {asDetail.data.es_date && <>({moment(asDetail.data.es_date).format("YYYY.MM.DD HH:mm")})</>} */}
                  </span>
                </Link>
              ) : (
                <span>
                  {asDetail.data.free_yn === "Y" ? "무상견적서" : "견적서"}
                  {/* {asDetail.data.es_date && <>({moment(asDetail.data.es_date).format("YYYY.MM.DD HH:mm")})</>} */}
                </span>
              )}
            </>
          ) : (
            ""
          )}
          {userInfo.user_type === "S" ? (
            <>
              {userInfo.store_type === "B" || userInfo.store_type === "O" ? (
                <>
                  {asDetail.data.es_approval_code !== "EAC_10" ? (
                    <Link to={"/estimate-detail/" + asDetail.data.es_idx} className="has-data">
                      <span>
                        {asDetail.data.free_yn === "Y" ? "무상견적서" : "견적서"}
                        {/* {asDetail.data.es_date && <>({moment(asDetail.data.es_date).format("YYYY.MM.DD HH:mm")})</>} */}
                      </span>
                    </Link>
                  ) : (
                    <span>
                      {asDetail.data.free_yn === "Y" ? "무상견적서" : "견적서"}
                      {/* {asDetail.data.es_date && <>({moment(asDetail.data.es_date).format("YYYY.MM.DD HH:mm")})</>} */}
                    </span>
                  )}
                </>
              ) : (
                <span>
                  {asDetail.data.free_yn === "Y" ? "무상견적서" : "견적서"}
                  {/* {asDetail.data.es_date && <>({moment(asDetail.data.es_date).format("YYYY.MM.DD HH:mm")})</>} */}
                </span>
              )}
            </>
          ) : (
            ""
          )}
          <>
            {userInfo.user_type === "M" ? (
              <>
                {asDetail.data.es_approval_code === "EAC_10" && asDetail.data.delete_yn !== "Y" ? (
                  <>
                    {asDetail.data.free_yn === "Y" ? (
                      <Button variant="outlined" size="small" br="round" onClick={() => addRegister()}>
                        등록
                      </Button>
                    ) : (
                      <Button variant="outlined" size="small" br="round" onClick={() => addRegister()}>
                        등록
                      </Button>
                    )}
                  </>
                ) : asDetail.data.es_approval_code === "EAC_20" && asDetail.data.delete_yn !== "Y" ? (
                  <Button variant="outlined" size="small" br="round" onClick={() => addRegister()}>
                    재등록
                  </Button>
                ) : (
                  <span className={className}>
                    {estimateState}
                    {asDetail.data.es_approved_date !== null ? `(${moment(asDetail.data.es_approved_date).format("YYYY.MM.DD")})` : ""}
                  </span>
                )}
              </>
            ) : (
              <span className={className}>
                {estimateState}
                {asDetail.data.es_approved_date !== null ? `(${moment(asDetail.data.es_approved_date).format("YYYY.MM.DD")})` : ""}
              </span>
            )}
          </>
        </li>
        <li>
          {isEmpty(asDetail.data.visit_date) ? (
            <span>방문정보</span>
          ) : (
            <p className="has-data" onClick={() => visitInfoMove()}>
              <span>방문정보</span>
            </p>
          )}
          <span className={cn({ isNum: asDetail.data.visit_date })}>
            {asDetail.data.visit_date ? (
              `방문(${moment(asDetail.data.visit_date).format("YYYY.MM.DD")})`
            ) : (
              <>
                {userInfo.user_type === "M" ? (
                  <>
                    {asDetail.data.delete_yn !== "Y" ? (
                      <>
                        <Button variant="outlined" size="small" br="round" onClick={() => addVisit()}>
                          등록
                        </Button>
                      </>
                    ) : (
                      "취소"
                    )}
                  </>
                ) : (
                  "미정"
                )}
              </>
            )}
          </span>
        </li>
        <li>
          {asDetail.data.progress_value === "100" ? (
            <Link to={"/report-detail/" + index} className="has-data" state={{ deleteYn: asDetail.data.delete_yn, esCode: asDetail.data.es_approval_code }}>
              <span>완료보고</span>
            </Link>
          ) : (
            <span>완료보고</span>
          )}

          {!isEmpty(asDetail.data.visit_date) ? (
            <>
              {userInfo.user_type === "M" ? (
                <>
                  {asDetail.data.completionReport_progress === "ASC_10" && (
                    <>
                      {new Date(String(asDetail.data.visit_date)) <= new Date(moment(new Date()).format("YYYY-MM-DD")) ? (
                        <>
                          {asDetail.data.delete_yn !== "Y" ? (
                            <span>
                              <Button variant="outlined" size="small" br="round" onClick={completeRegisteMove}>
                                등록
                              </Button>
                            </span>
                          ) : (
                            "미제출"
                          )}
                        </>
                      ) : (
                        <span>작업 전</span>
                      )}
                    </>
                  )}
                  {asDetail.data.completionReport_progress === "ASC_70" && (
                    <>
                      {asDetail.data.delete_yn !== "Y" ? (
                        <span>
                          <Button variant="outlined" size="small" br="round" onClick={completeRegisteMove}>
                            보완
                          </Button>
                        </span>
                      ) : (
                        "보완요청"
                      )}
                    </>
                  )}
                  {asDetail.data.completionReport_progress === "ASC_50" || asDetail.data.completionReport_progress === "ASC_100" ? (
                    <span className={asDetail.data.completionReport_progress === "ASC_100" ? "check-blue" : ""}>
                      {completeInfo}
                      {asDetail.data.completion_approved_date !== null ? `(${moment(asDetail.data.completion_approved_date).format("YYYY.MM.DD")})` : ""}
                    </span>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <span className={asDetail.data.completionReport_progress === "ASC_100" ? "check-blue" : ""}>
                  {completeInfo}
                  {asDetail.data.completion_approved_date !== null ? `(${moment(asDetail.data.completion_approved_date).format("YYYY.MM.DD")})` : ""}
                </span>
              )}
            </>
          ) : (
            <span>작업 전</span>
          )}

          {/* {asDetail.data.progress_value === "80" ? <Link to={"/report-register/" + index}>미제출</Link> : completeInfo} */}
        </li>
      </VenderStatusBox>
    </Box>
  );
};

const VenderInfoBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-start")}
  .name {
    font-size: 18px;
    font-weight: 700;
  }
  .tel {
    font-family: "Poppins";
    font-weight: 400;
    margin-top: 5px;
  }
`;

const VenderStatusBox = styled.ul`
  padding-top: 15px;
  margin-top: 30px;
  border-top: 2px solid #000;
  > li {
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-start")}
    padding: 15px 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.lineSecondary};
    color: ${({ theme }) => theme.color.tertiary};
    font-family: "Poppins";
    font-size: 16px;
    font-weight: 400;
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
    .has-data {
      display: inline-block;
      padding-left: 26px;
      text-decoration: underline;
      background: url(${iconDoc}) no-repeat left center;
      color: #000;
      > span {
        background: #b4dcec 0% 0% no-repeat padding-box;
      }
    }
    .check-blue {
      /* padding-left: 19px; */
      color: ${({ theme }) => theme.color.subMain};
      /* background: url(${iconCheckBlue}) no-repeat left center; */
    }
    .check-red {
      padding-left: 19px;
      color: ${({ theme }) => theme.color.warning};
      background: url(${iconCheckRed}) no-repeat left center;
    }
    .check-black {
      padding-left: 19px;
      color: #000;
      background: url(${iconCheckBlack}) no-repeat left center;
    }
    .isNum {
      color: ${({ theme }) => theme.color.subMain};
      font-size: 16px;
    }
  }
`;

export default SelectVender;
